"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = void 0;
var getStyles = function (_a) {
    var _b = _a.fontName, fontName = _b === void 0 ? 'Calibri' : _b, _c = _a.fontColorRgb, fontColorRgb = _c === void 0 ? '333333' : _c, _d = _a.fontBold, fontBold = _d === void 0 ? false : _d, _e = _a.fillFgColorRgb, fillFgColorRgb = _e === void 0 ? 'ffffff' : _e, _f = _a.borderStyle, borderStyle = _f === void 0 ? 'thin' : _f, _g = _a.borderColorRgb, borderColorRgb = _g === void 0 ? 'd1d3d8' : _g, _h = _a.alignmentHorizontal, alignmentHorizontal = _h === void 0 ? 'center' : _h, // left center right
    _j = _a.alignmentVertical, // left center right
    alignmentVertical = _j === void 0 ? 'center' : _j, // top center bottom
    _k = _a.alignmentWrapText, // top center bottom
    alignmentWrapText = _k === void 0 ? false : _k, // true false
    _l = _a.alignmentReadingOrder, // true false
    alignmentReadingOrder = _l === void 0 ? 2 : _l, // for right-to-left
    _m = _a.alignmentTextRotation, // for right-to-left
    alignmentTextRotation = _m === void 0 ? 0 : _m;
    return {
        fill: {
            fgColor: { rgb: formatRgb(fillFgColorRgb) }
        },
        font: {
            name: fontName,
            color: { rgb: formatRgb(fontColorRgb) },
            bold: fontBold,
        },
        border: getDefaultBorder({ style: borderStyle, colorRgb: formatRgb(borderColorRgb) }),
        numFmt: undefined,
        alignment: {
            horizontal: alignmentHorizontal,
            vertical: alignmentVertical,
            wrapText: alignmentWrapText,
            readingOrder: alignmentReadingOrder,
            textRotation: alignmentTextRotation,
        },
    };
};
exports.getStyles = getStyles;
var getDefaultBorder = function (_a) {
    var _b = _a.style, style = _b === void 0 ? 'thin' : _b, _c = _a.colorRgb, colorRgb = _c === void 0 ? 'd1d3d8' : _c;
    var border = {
        top: {
            style: style,
            color: {
                rgb: colorRgb, // ARGB
                // auto: 1,
                // theme: '1',
                // tint: '-0.25',
                // index: 64
            }
        },
        left: {
            style: style,
            color: { rgb: colorRgb }
        },
        bottom: {
            style: style,
            color: { rgb: colorRgb }
        },
        right: {
            style: style,
            color: { rgb: colorRgb }
        },
        diagonal: {
            style: style,
            color: { rgb: colorRgb }
        }
    };
    return border;
};
var formatRgb = function (hex) {
    return hex.replace('#', '');
};
